import PhoneConfirmationModal from './component';
import { PhoneConfirmationModalProps } from './types';

export default PhoneConfirmationModal;
export type { PhoneConfirmationModalProps };
